import { NotificationEventType, TrackingEventOf } from './types';

export const getNotificationSummary = (event: TrackingEventOf<NotificationEventType>) => {
  const exceptionKey = event?.tracking_status.toLowerCase() as Lowercase<
    typeof event['tracking_status']
  >;

  return event?.exception?.[exceptionKey]?.summary;
};
